import { Box, Flex, Text, Image, Modal, ModalOverlay, ModalContent, ModalBody, useDisclosure } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { FaPlay } from "react-icons/fa";
import NextImage from "next/image";
import React from "react";

const PurchaseProof = ({ purchaseProof, fonts, highlighted = false }) => {
    const { titleFont } = fonts;
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedProof, setSelectedProof] = React.useState(null);

    const handlePreview = (proof) => {
        setSelectedProof(proof);
        onOpen();
    };

    return (
        <>
            <Box
                w="100%"
                boxShadow={highlighted ? "none" : "9.6px 9.6px 0px #222"}
                borderRadius="6px"
                bg="#f2f7f5"
                border={highlighted ? "0.7px solid #000" : "1px solid #000"}
                overflow="hidden"
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                p="25px 20px"
                gap="20px"
                fontSize="20px"
                color="#000"
                fontFamily="Comfortaa"
            >
                <Box alignSelf="stretch" display="flex" flexDirection="row" alignItems="flex-start">
                    <Text flex={1} lineHeight="24px" fontFamily={titleFont}>
                        <Trans>Bukti Pembelian Wishlist</Trans>
                    </Text>
                </Box>
                
                <Flex direction="row" align="flex-start" gap="20px" wrap="wrap">
                    {purchaseProof?.map((proof, index) => (
                        <Box 
                            key={index} 
                            position="relative" 
                            width="100px" 
                            height="100px" 
                            marginTop={3} 
                            marginRight={3}
                            cursor="pointer"
                            onClick={() => handlePreview(proof)}
                        >
                            {proof.file_type === "VIDEO" ? (
                                <>
                                    <Image
                                        position="absolute"
                                        top="0px"
                                        left="0px"
                                        borderRadius="8px"
                                        width="100px"
                                        height="100px"
                                        objectFit="cover"
                                        src={proof.thumbnail_url}
                                        alt="Video thumbnail"
                                    />
                                    <Box
                                        position="absolute"
                                        top="calc(50% - 17.5px)"
                                        left="calc(50% - 17.5px)"
                                        width="35px"
                                        height="35px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <FaPlay size="35px" color="white" />
                                    </Box>
                                </>
                            ) : (
                                <Image
                                    width="100px"
                                    borderRadius="6px"
                                    height="100px"
                                    objectFit="cover"
                                    src={proof.file_url}
                                    alt={t`Bukti Pembelian Wishlist`}
                                />
                            )}
                        </Box>
                    ))}
                </Flex>
            </Box>

            {/* Preview Modal */}
            <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent 
                    maxWidth="none" 
                    bg="transparent" 
                    boxShadow="none"
                    width="auto"
                >
                    <Box
                        position="relative"
                        boxShadow="9.6px 9.6px 0px #222"
                        borderRadius="6px"
                        bg="#f2f7f5"
                        border="1px solid #000"
                        w="100%"
                        overflow="hidden"
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        p="21px 17px"
                        gap="16px"
                        fontSize="20px"
                        color="#000"
                        fontFamily="Comfortaa"
                    >
                        {/* Header */}
                        <Flex
                            alignSelf="stretch"
                            direction="row"
                            align="center"
                            justify="space-between"
                        >
                            <Text lineHeight="24px">
                                <Trans>Foto/Video</Trans>
                            </Text>
                            <Box
                                width="32px"
                                maxHeight="100%"
                                overflow="hidden"
                                flexShrink={0}
                                cursor="pointer"
                                onClick={onClose}
                            >
                                ✕
                            </Box>
                        </Flex>

                        {/* Content */}
                        {selectedProof?.file_type === "VIDEO" ? (
                            <video
                                width="500px"
                                height="500px"
                                borderRadius="6px"
                                style={{ objectFit: "cover" }}
                                controls
                                autoPlay
                                src={selectedProof.file_url}
                            />
                        ) : (
                            <Image
                                width="500px"
                                borderRadius="6px"
                                height="500px"
                                objectFit="cover"
                                src={selectedProof?.file_url}
                                alt="Preview"
                            />
                        )}
                    </Box>
                </ModalContent>
            </Modal>

        </>
    );
};

export default PurchaseProof;
